import { Box, Stack, Typography } from '@mui/material';

import type { CalibrationMatrixWindows } from '@/api/types/calibrationMatrix.types';

interface WindowLegendProps {
  windows: CalibrationMatrixWindows;
}

interface LegendItem {
  key: 'promotion' | 'electcomm' | 'formalElectcomm';
  label: string;
  bgcolor: string;
}

const ALL_ITEMS: LegendItem[] = [
  { key: 'promotion', label: 'Promotion window', bgcolor: 'custom.lightPeach' },
  { key: 'electcomm', label: 'Electcom window', bgcolor: 'custom.cappuccino' },
  { key: 'formalElectcomm', label: 'Electcom formal review', bgcolor: 'custom.gold' },
];

export function WindowLegend({ windows }: WindowLegendProps) {
  const items = ALL_ITEMS.filter((item) => {
    const tierEntries = windows[item.key];
    return tierEntries != null && tierEntries.length > 0;
  });

  if (items.length === 0) return null;

  return (
    <Stack
      direction="row"
      spacing={2}
      role="list"
      aria-label="Matrix window legend"
      data-testid="matrix-window-legend"
      sx={{ mb: 1 }}
    >
      {items.map((item) => (
        <Stack
          key={item.key}
          role="listitem"
          direction="row"
          spacing={1}
          alignItems="center"
        >
          <Box
            aria-hidden
            sx={{
              width: 24,
              height: 16,
              bgcolor: item.bgcolor,
              border: 1,
              borderColor: 'divider',
            }}
          />
          <Typography variant="body2">{item.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}

export default WindowLegend;
